export default import.meta.ROLLUP_FILE_URL_e3FJByPCCgv8fip_DM$mWQ;